/* eslint-disable import/no-cycle */
import i18n from '../../../i18n/i18n';

export const getPagination = (paginationEntries, showTotal) => ({
  pageSize: paginationEntries || null,
  showTotal: showTotal
    ? ((total, range) => i18n.t('pagination.range', {from: range[0], to: range[1], total}))
    : null,
});
